import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Async thunk for fetching requests
export const fetchRequests = createAsyncThunk(
  'requests/fetchRequests',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching requests from API...');
      const response = await api.get('/requests');
      console.log('Requests fetched:', response.data.requests.length, 'requests');
      console.log('First request results:', response.data.requests[0]?.results?.length || 0, 'results');
      return response.data.requests;
    } catch (error) {
      console.error('Error fetching requests:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch requests');
    }
  }
);

const requestsSlice = createSlice({
  name: 'requests',
  initialState: {
    requests: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.requests = action.payload;
        console.log('Redux state updated with', action.payload.length, 'requests');
      })
      .addCase(fetchRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = requestsSlice.actions;
export default requestsSlice.reducer;

